<template>
  <div class="weekly-activity">
    <v-chart ref="chart" autoresize :options="chart"/>
    <div class="weekly-activity__controls">
      <sw-button
        class="weekly-activity__control"
        v-model="parameters.rangeMode"
        :label="$t('component.chart.rangeMode')"
      ></sw-button>
      <div v-if="!parameters.rangeMode">
        <min-sel v-model="parameters.hours" @input="hoursChange">
          <option :value="336">2 {{ $t('component.chart.weeks') }}</option>
          <option :value="730">1 {{ $t('component.chart.month') }}</option>
          <option :value="2191">3 {{ $t('component.chart.months') }}</option>
          <option :value="4383">6 {{ $t('component.chart.months') }}</option>
          <option :value="8766">12 {{ $t('component.chart.months') }}</option>
        </min-sel>
      </div>
      <div class="weekly-activity__range" v-else>
        <in
          type="date"
          @input="rangeInput"
          class="weekly-activity__control"
          v-model="parameters.rangeStart"
          :label="$t('component.chart.rangeStart')"
        ></in>
        <in
          type="date"
          @input="rangeInput"
          class="weekly-activity__control"
          v-model="parameters.rangeStop"
          :label="$t('component.chart.rangeStop')"
        ></in>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  data() {
    const that = this
    return {
      parameters: {
        hours: 336,
        rangeMode: false,
        rangeStart: null,
        rangeStop: null
      },
      chart: {
        title: {
          text: this.$t('view.dashboard.weekActivity')
        },
        tooltip: {
          formatter: function (params) {
            return params.value[2] + ' ' + that.$t('view.dashboard.messagesReceivedOn') + ' ' + that.$t(`date.day[${params.value[1]}]`) + ' (' + params.value[0] + ':00 - ' + (parseInt(params.value[0]) + 1) + ':00)'
          }
        },
        toolbox: {
          show: true,
          feature: {
            magicType: { show: true, type: ['stack', 'tiled'], title: { stack: this.$t('component.chart.stack'), tiled: this.$t('component.chart.tiled') } },
            saveAsImage: { show: true, title: this.$t('component.chart.saveAsImage') }
          }
        },
        xAxis: {
          type: 'category',
          data: ['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00',
            '7:00', '8:00', '9:00', '10:00', '11:00',
            '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
            '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          splitArea: {
            show: true
          }
        },
        yAxis: {
          type: 'category',
          data: [this.$t('date.day[0]'), this.$t('date.day[1]'), this.$t('date.day[2]'),
          this.$t('date.day[3]'), this.$t('date.day[4]'), this.$t('date.day[5]'), this.$t('date.day[6]')],
          inverse: true,
          splitArea: {
            show: true
          }
        },
        visualMap: {
          min: 0,
          max: 1,
          calculable: true,
          orient: 'vertical',
          left: '91%',
          bottom: 'center',
          display: 'none',
          inRange: {
            color: ['#e8f5e9', '#4daa57']
          }
        },
        series: [{
          name: 'Punch Card',
          type: 'heatmap',
          data: [],
          label: {
            show: false
          }
        }]
      }
    }
  },
  methods: {
    transformDay(date) {
      let d = date.getDay()
      if (d !== 0) return d - 1
      else return 6
    },

    isInfinity(v){
      return (v === Infinity || v === -Infinity)
    },

    loadDataToChart(data) {
      let prepared = []
      let all = []
      let tempObject = {}
      for (let i = 0; i < data.length; i++) {
        data[i].date = new Date(data[i].date)
        if (!tempObject[this.transformDay(data[i].date)]) tempObject[this.transformDay(data[i].date)] = {}
        if (!tempObject[this.transformDay(data[i].date)][data[i].date.getHours()]) tempObject[this.transformDay(data[i].date)][data[i].date.getHours()] = 0
        tempObject[this.transformDay(data[i].date)][data[i].date.getHours()] += data[i].messenger_messages_incoming + data[i].webchat_messages_incoming
      }
      for (let i = 0; i < Object.keys(tempObject).length; i++) {
        if (!tempObject[i]) continue
        const day = Object.keys(tempObject)[i]
        for (let o = 0; o < Object.keys(tempObject[i]).length; o++) {
          const hour = Object.keys(tempObject[day])[o]
          prepared.push([+hour, +day, tempObject[day][hour] || 0])
          all.push(tempObject[day][hour] || 0)
        }
      }

      let sum = 0
      for (let i = 0; i < all.length; i++) {
        sum += all[i]
      }

      this.chart.series[0].data = prepared
      const max = Math.max(...all)
      const min = Math.min(...all)
      if (!this.isInfinity(max) && !this.isInfinity(min) && !isNaN(max) && !isNaN(min)) {
        this.chart.visualMap.max = max
        this.chart.visualMap.min = min
      }
    },

    async hoursChange(v) {
      try {
        const dataReq = await axios.get(`/api/stats/hourly?hours=${v}`)
        this.loadDataToChart(dataReq.data.rows)
      } catch (e) {
        console.error(e)
      }
    },

    async rangeInput() {
      try {
        const start = this.parameters.rangeStart
        const stop = this.parameters.rangeStop
        if (!start || !stop) return
        const dataReq = await axios.get(`/api/stats/hourly-range?start=${start}&stop=${stop}`)
        this.loadDataToChart(dataReq.data.rows)
      } catch (e) {
        console.error(e)
      }
    }
  },
  async created() {
    try {
      const rowsReq = await axios.get('/api/stats/hourly?hours=336')
      this.loadDataToChart(rowsReq.data.rows)
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.weekly-activity {
  @include flowElementShadow();
  background-color: white;
  margin-top: 11px;
  padding: 15px;
  border-radius: 4px;

  &__controls {
    @include alignedFlex(flex-start);
    @include standarizeStatControls();
  }

  &__control {
    margin-right: 20px;
  }

  &__range {
    @include alignedFlex(flex-start);
  }
}
</style>
